import { useTranslation } from "react-i18next";
import MainButton from "../sharedComponents/MainButton";

const CommentInput = ({ userAvatar, value, onChange, onSubmit }) => {
    const { t } = useTranslation();
    // console.log(value)
    const handleSubmit = () => {
        if (!value.trim()) return;
        onSubmit();
    };

    return (

        <div className="flex gap-4 p-4 border dark:bg-bg-dark-secondary bg-bg-light-secondary rounded-xl dark:border-border-dark border-border-light">

            {/* Avatar */}
            <img
                src={userAvatar}
                alt="avatar"
                className="object-cover w-10 h-10 rounded-full"
            />

            {/* Right side */}
            <div className="flex flex-col flex-1 gap-3">
                <textarea
                    value={value}
                    onChange={onChange}
                    placeholder={t("comment.placeholder")}
                    className="w-full py-3 text-black border resize-none ps-3 dark:text-white bg-bg-light-tertiary dark:bg-bg-dark-tertiary border-border-light dark:border-border-dark rounded-xl focus:outline-none focus:ring focus:ring-primary-light dark:focus:ring-primary"

                />
                {/* Actions */}
                <div className="flex justify-end">
                    <MainButton
                        onClick={handleSubmit}
                        disabled={!value?.trim()}
                        className={!value?.trim() ? "opacity-50 cursor-not-allowed" : ""}
                    >

                        <svg
                            className="inline w-4 h-4 me-2"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M22 2L11 13" />
                            <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                        </svg>
                        {t("post.post")}</MainButton>
                </div>
            </div>
        </div>
    );
};

export default CommentInput;
